import * as React from 'react';
import type { SVGProps } from 'react';
const SvgRefreshCcw01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 10s2.005-2.732 3.634-4.362A9 9 0 1 1 12 21a9.004 9.004 0 0 1-8.648-6.5M2 10V4m0 6h6"
    />
  </svg>
);
SvgRefreshCcw01.displayName = 'RefreshCcw01';
export default SvgRefreshCcw01;
